import { render } from "./ReviewDetailPanel.vue?vue&type=template&id=4ad562ba&scoped=true&ts=true"
import script from "./ReviewDetailPanel.vue?vue&type=script&lang=ts"
export * from "./ReviewDetailPanel.vue?vue&type=script&lang=ts"

import "./ReviewDetailPanel.vue?vue&type=style&index=0&id=4ad562ba&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad562ba"]])

export default __exports__